import React from 'react';
import { useTranslation } from 'react-i18next';
import { REPORT_CATEGORIES } from '../../services/ReportService';

const ReportCategorySelector = ({ selectedCategory, onCategoryChange }) => {
  const { t } = useTranslation('reports');

  return (
    <div className="report-category-selector">
      {REPORT_CATEGORIES.map((category) => (
        <button
          key={category.id}
          type="button"
          className={`category-tab${selectedCategory === category.id ? ' active' : ''}`}
          onClick={() => onCategoryChange(category.id)}
        >
          {t(category.labelKey)}
        </button>
      ))}
    </div>
  );
};

export default ReportCategorySelector;